export default __webpack_public_path__ + "images/VWTextCarUI-Bold.325e264c.ttf";